module.exports = __webpack_public_path__ + "static/media/СЗФО_2009.0b86031b.png";